import React, { useState } from "react";
import {
  faCheckCircle,
  faClose,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import SecureLS from "secure-ls";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessageModal from "./MessageModal";
import { mutate } from "swr";

const ls = new SecureLS({ encodingType: "aes" });

const AddVoucherCategory = () => {
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [isMessageModalVisible, setIsMessageModalVisible] = useState(false);

  const toggleModalClose = () => {
    setIsMessageModalVisible(false);
    setCategoryName("");
  };

  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const username = ls.get("username");
      const userpw = ls.get("userpw");
      const usercsrf_token = ls.get("usercsrf_token");

      if (!username || !userpw || !usercsrf_token) {
        alert("Missing credentials. Please log in again.");
        setLoading(false);
        return;
      }

      const categoryPayload = {
        vid: [{ target_id: "voucher_categories" }],
        name: [{ value: categoryName }],
      };

      const response = await fetch(
        `${process.env.REACT_APP_VOUCHER_TAXONOMY_TERM_API}?_format=json`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
            "X-CSRF-Token": usercsrf_token,
          },
          body: JSON.stringify(categoryPayload),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        alert(`Error creating category: ${errorText}`);
        setLoading(false);
        return;
      }

      setIsMessageModalVisible(true);
      mutate(`${process.env.REACT_APP_VOUCHER_TAXONOMY_CATEGORIES_TERM_API}`);
    } catch (error) {
      console.error("Network Error:", error);
      alert("Network Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-ctscan-request-register">
      <form onSubmit={handleCategorySubmit} className="patient-form">
        <div className="form-group">
          <label>Voucher Category Name:</label>
          <input
            type="text"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="e.g. Free Health Screening, Food, Transport"
            required
          />
        </div>

        <div className="submitGroup">
          <button type="submit" disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin fontSize={22} />
            ) : (
              "Add Category"
            )}
          </button>
        </div>
      </form>

      {isMessageModalVisible && (
        <MessageModal
          leftIcon={faCheckCircle}
          color="green"
          fontSize={20}
          message="Voucher category added successfully!"
          onClose={toggleModalClose}
          rightIcon={faClose}
        />
      )}
    </div>
  );
};

export default AddVoucherCategory;
